import axios from 'axios';
import { urlSendMessage } from '../utils';

export const apiSendMessage = axios.create({
    baseURL: `${urlSendMessage}`
});